export const LESS_THAN_FIELD_MESSAGE = 'validationMessages:less_than_field_message';
export const BIGGER_THAN_FIELD_MESSAGE = 'validationMessages:bigger_than_field_message';
export const REQUIRED_MESSAGE = 'validationMessages:required_message';
export const BIGGER_THAN_ZERO_MESSAGE = 'validationMessages:bigger_than_zero_message';
export const BIGGER_THAN_THIS_YEAR_MESSAGE = 'validationMessages:bigger_than_this_year_message';
export const BIGGER_THAN_CHAR_MESSAGE = 'validationMessages:bigger_than_char_message';
export const LESS_THAN_CHAR_MESSAGE = 'validationMessages:less_than_char_message';
export const PASSWORD_MESSAGE = 'validationMessages:password';
export const UNIQUE_ERROR_MESSAGE = 'validationMessages:unique_error_message';
export const INTERSECT_TIME_ERROR_MESSAGE = 'validationMessages:intersect_time_error_message';
export const EMAIL_MESSAGE = 'validationMessages:email';
export const URL_MESSAGE = 'validationMessages:url';
export const GROUPED_REQUIRES_SECOND_GROUP = "validationMessages:grouped_requires_second_group";
